export default "__VITE_ASSET__31857580__"